import { useEffect, useState } from 'react'

import { useToasts } from '@/hooks/useToasts'
import { useTranslation } from 'react-i18next'

import { useUpdateAiOperatorResponseRulesMutation } from '@/graphql/generated/hooks'

export const useUpdateIncidentRules = ({
  isDryRunInitial,
  isDryRunInitialLoading,
  ruleId,
}: {
  isDryRunInitial: boolean
  isDryRunInitialLoading: boolean
  ruleId: string
}) => {
  const { t } = useTranslation()
  const { showError, showSuccess } = useToasts()
  const [isDryRun, setIsDryRun] = useState(null)

  useEffect(() => {
    setIsDryRun(isDryRunInitial)
  }, [isDryRunInitial])

  const [updateAiOperatorRuleMutation, { loading: isUpdateLoading }] =
    useUpdateAiOperatorResponseRulesMutation()

  const onDryRunToggle = async () => {
    try {
      await updateAiOperatorRuleMutation({
        variables: {
          input: {
            isDryRun: !isDryRun,
            ruleId,
          },
        },
      })
      setIsDryRun((prevIsDryRun) => !prevIsDryRun)
      showSuccess(t('automations:ai_dry_run_updated_success'))
    } catch (e) {
      showError(t('automations:ai_dry_run_updated_error'))
    }
  }

  return {
    isDryRun,
    isLoading: isUpdateLoading || isDryRunInitialLoading,
    onDryRunToggle,
  }
}
